"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchButton;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Form = require("../../organisms/Form");

var _atoms = require("../../atoms");

var _Icons = require("../../atoms/Icons");

var _SearchButtonModule = _interopRequireDefault(require("./SearchButton.module.css"));

var _excluded = ["onSearch", "formInput", "type", "noMt", "className", "inputClassName", "iconClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SearchButton(_ref) {
  var onSearch = _ref.onSearch,
      _ref$formInput = _ref.formInput,
      formInput = _ref$formInput === void 0 ? false : _ref$formInput,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$noMt = _ref.noMt,
      noMt = _ref$noMt === void 0 ? true : _ref$noMt,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$inputClassName = _ref.inputClassName,
      inputClassName = _ref$inputClassName === void 0 ? '' : _ref$inputClassName,
      _ref$iconClassName = _ref.iconClassName,
      iconClassName = _ref$iconClassName === void 0 ? '' : _ref$iconClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  var InputComponent = formInput ? _Form.FormInput : _atoms.Input;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_SearchButtonModule.default.SearchButton, " grid grid-cols-12 grid-flow-col ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('col-span-9 pr-1', inputClassName)
  }, /*#__PURE__*/_react.default.createElement(InputComponent, _extends({
    noMt: noMt
  }, props))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('col-span-3 pl-1', iconClassName)
  }, /*#__PURE__*/_react.default.createElement(_atoms.Button, {
    onClick: onSearch,
    type: type,
    block: true,
    className: "grid place-content-center ".concat(_SearchButtonModule.default.search)
  }, /*#__PURE__*/_react.default.createElement(_Icons.Search, {
    width: "1.4rem",
    height: "1.4rem",
    fill: "white"
  }))));
}

SearchButton.propTypes = {
  onSearch: _propTypes.default.func,
  formInput: _propTypes.default.bool,
  type: _propTypes.default.string,
  noMt: _propTypes.default.bool,
  className: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  iconClassName: _propTypes.default.string
};